export const quotationIconSVG = (value: boolean, selected: string, disabled: string) => (
	<svg
		version="1.0"
		xmlns="http://www.w3.org/2000/svg"
		width="16"
		viewBox="0 0 512.000000 512.000000"
		preserveAspectRatio="xMidYMid meet"
	>
		<g
			transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
			fill={value ? selected : disabled}
			stroke="none"
		>
			<path
				d="M78 5099 c-23 -12 -46 -35 -58 -59 -20 -39 -20 -55 -20 -2030 0
        -1947 0 -1992 19 -2028 24 -46 924 -944 968 -966 29 -14 164 -16 1398 -16
        1349 0 1366 0 1405 20 26 13 47 34 60 60 20 39 20 53 20 2480 0 2427 0 2441
        -20 2480 -13 26 -34 47 -60 60 -39 20 -54 20 -1857 20 -1790 -1 -1819 -1
        -1855 -21z m3492 -2539 l0 -2260 -1185 0 -1185 0 0 390 c0 372 -1 393 -20 430
        -13 26 -34 47 -60 60 -37 19 -58 20 -430 20 l-390 0 0 1810 0 1810 1635 0
        1635 0 0 -2260z m-2670 -1850 c0 -104 -1 -190 -3 -190 -1 0 -88 86 -192 190
        l-190 190 193 0 192 0 0 -190z"
			/>
			<path
				d="M1737 4505 c-567 -93 -1001 -511 -1114 -1073 -25 -122 -24 -385 1
        -501 92 -429 361 -773 747 -955 421 -199 921 -159 1316 105 101 67 285 252
        353 353 351 525 295 1213 -136 1666 -191 200 -424 332 -689 390 -130 28 -354
        35 -478 15z m458 -319 c453 -117 775 -533 775 -1001 0 -515 -378 -951 -889
        -1026 -109 -15 -292 -6 -394 20 -369 96 -656 380 -754 746 -23 87 -26 120 -27
        255 0 128 3 170 22 243 102 407 419 703 835 783 111 21 308 12 432 -20z"
			/>
			<path
				d="M1862 3983 c-48 -23 -75 -67 -80 -129 -4 -51 -6 -55 -53 -85 -115
        -73 -173 -178 -173 -314 -1 -71 3 -88 32 -147 54 -110 134 -168 327 -238 50
        -18 100 -42 113 -53 44 -41 17 -128 -51 -160 -59 -28 -132 -22 -211 18 -81 41
        -116 43 -170 12 -69 -40 -94 -121 -59 -194 20 -43 111 -105 188 -129 l53 -17
        4 -48 c9 -90 80 -148 169 -136 77 10 129 74 129 160 0 43 1 45 58 80 78 48
        137 114 175 195 30 62 32 75 31 167 0 79 -4 109 -21 145 -52 113 -134 180
        -285 235 -56 21 -115 44 -130 51 -62 32 -74 69 -33 109 33 34 85 33 160 -5 89
        -45 165 -36 213 25 70 88 21 200 -114 262 -50 23 -52 24 -56 72 -11 110 -118
        172 -216 124z"
			/>
			<path
				d="M1595 1536 c-56 -25 -95 -85 -95 -144 0 -40 41 -103 80 -123 33 -18
        74 -19 803 -19 847 0 812 -3 858 62 52 72 25 179 -55 217 -42 21 -55 21 -802
        21 -610 -1 -765 -3 -789 -14z"
			/>
			<path
				d="M1595 936 c-56 -25 -95 -85 -95 -144 0 -40 41 -103 80 -123 33 -18
        74 -19 803 -19 847 0 812 -3 858 62 52 72 25 179 -55 217 -42 21 -55 21 -802
        21 -610 -1 -765 -3 -789 -14z"
			/>
			<path
				d="M4435 5111 c-99 -26 -188 -99 -232 -190 l-28 -56 -3 -1872 -2 -1871
        166 -509 c91 -279 173 -521 182 -537 53 -91 183 -99 245 -15 10 14 95 259 188
        543 l169 518 -2 1871 -3 1872 -22 48 c-31 66 -105 142 -172 174 -55 27 -60 28
        -256 30 -110 1 -213 -2 -230 -6z m373 -303 c8 -8 12 -62 12 -175 l0 -163 -175
        0 -175 0 0 163 c0 113 4 167 12 175 17 17 309 17 326 0z m12 -2073 l0 -1435
        -175 0 -175 0 0 1435 0 1435 175 0 175 0 0 -1435z m-60 -1741 c0 -8 -110 -348
        -114 -351 -3 -3 -116 339 -116 351 0 3 52 6 115 6 63 0 115 -3 115 -6z"
			/>
		</g>
	</svg>
);
